import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import useModals from '../../../../hooks/useModals'
import {DELETE, GET, POST, PUT} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {i18n} from '../../../../translate/i18n'
import {Input} from '../../../../components/Input/Input'
import {Dropdown} from 'react-bootstrap'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import {useSwitchStatus} from '../../../../components/Datatable/SwitchStatus'

type VariationType = {
  id: number
  sku: string
  name: string
  specification: string
  inventory: number
  price: number
  status: boolean
}

type VariationResponseType = {
  id: number
  sku: string
  name: string
  code: string
  classificationName: string
  context: string
  imgs: string
  inventory: number
  price: number
  promotionalPrice: number
  productStatus: boolean
  variationStatus: boolean
}

type LocationType = {
  id: number
  name: string
  type: string
  status: boolean
  code?: string
}

type SelectType = {
  value: number
  select: string
}

const VariacoesContent: FC = () => {
  const navigate = useNavigate()
  const {showDeleteModal, showWrapperModal} = useModals()
  const {switchStatus} = useSwitchStatus()
  const [loading, setLoading] = useState(false)
  const {useTotvs} = usePluginsSpace()
  const [variations, setVariations] = useState<VariationType[]>([])
  const [variationId, setVariationId] = useState<number | null>(null)
  const [locationId, setLocationId] = useState(-1)
  const [locations, setLocations] = useState<SelectType[]>([])

  const [disableFieldsTotvs, setDisableFieldTotvs] = useState(false)
  const [fileToImport, setFileToImport] = useState<File | null>(null)

  const getVariations = async (locationIdSend: number) => {
    try {
      if (useTotvs) {
        setDisableFieldTotvs(true)
      }

      const res = await POST(`/product/with-variations`, {
        haveImage: -1,
        havePrice: -1,
        productStatus: -1,
        variationStatus: -1,
        haveInventory: -1,
        classificationId: -3,
        locationId: locationIdSend ? locationIdSend : -1,
      })
      const newVariations = res.data.map((row: VariationResponseType) => {
        let specification = `<div class='d-flex flex-column'>`
        if (!row.context.includes('VARIATION') && !row.context.includes('NONE')) {
          const contextFormated = JSON.parse(row.context)
          if (contextFormated) {
            Object.entries(contextFormated).forEach((item) => {
              specification += `<p>${item[0]}: ${item[1]}</p>`
            })
          }
        }
        specification += '</div>'
        return {
          id: row.id,
          sku: row.sku,
          code: row.code,
          name: row.name,
          specification: specification,
          inventory: row.inventory,
          price: row.price,
          status: row.variationStatus,
        }
      })
      setVariations(newVariations)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const deleteVariation = async () => {
    try {
      setLoading(true)
      const variationRes = await DELETE(`/variations/${variationId}`)
      if (variationRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Variação deletada',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getVariations(locationId))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar a variação!',
        }).then(async () => await getVariations(locationId))
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar a variação!',
      }).then(async () => await getVariations(locationId))
      console.log(e)
    }
  }

  // const switchStatus = async (id: number, status: boolean) => {
  //   try {
  //     const switchVariation = await PUT(`/variations/${id}`, {
  //       status: !status,
  //     })
  //     if (switchVariation.success) {
  //       const newVariations = variations.map((variation) => {
  //         if (variation.id === id) {
  //           variation.status = !status
  //         }
  //         return variation
  //       })
  //       setVariations(newVariations)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  const changeVariation = async (item: any, valueChange: string) => {
    let objectToChange: any = {}
    objectToChange[valueChange] = item[valueChange]
    try {
      const switchVariation = await PUT(`/variations/${item.id}`, objectToChange)
      if (switchVariation.success) {
        const newVariations = variations.map((variation: any) => {
          if (variation.id === item.id) {
            variation[valueChange] = item[valueChange]
          }
          return variation
        })
        setVariations(newVariations)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getLocations = async () => {
    try {
      const res = await GET(`/location`)
      const newLocations: LocationType[] = [
        {
          id: -1,
          name: 'Todas',
          type: '',
          status: true,
        },
      ]
      res.data.forEach((location: LocationType) => {
        if (location.type !== 'address') {
          newLocations.push(location)
        }
      })
      setLocations(
        newLocations.map((loc) => ({
          value: loc.id,
          select: loc.name,
        }))
      )
      const locationActive =
        newLocations.find((loc) => loc.status === true && loc.code === 'withdraw') ||
        newLocations.find((loc) => loc.status === true && loc.id > 0)
      if (locationActive) {
        setLocationId(locationActive.id)
        await getVariations(locationActive.id)
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const init = async () => {
    setLoading(true)
    await getLocations()
    setLoading(false)
  }

  const importFile = async () => {
    try {
      if (!fileToImport) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se foi selecionado um arquivo!',
        })
      } else {
        setLoading(true)
        const formData = new FormData()
        formData.append('file', fileToImport)

        const importRes = await POST('/product/import_minimum_stock', formData)
        setLoading(false)
        if (importRes.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Importação realizada com sucesso!',
          }).then(async () => {
            await getLocations()
            await getVariations(locationId)
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao importar arquivo!',
          }).then(async () => {
            await getLocations()
            await getVariations(locationId)
          })
        }
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e,
      }).then(async () => {
        await getLocations()
        await getVariations(locationId)
      })
    }
    setFileToImport(null)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`smart_order.variations`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`smart_order.listened_variations`)}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`buttons.add_variation`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/variation/criar')}
                  btnClass='mb-5 fw-bolder'
                />

                <Dropdown
                  className='btn btn-primary btn-sm fw-bolder me-5 p-0 mb-5 dropdown '
                  style={{marginLeft: '1em'}}
                >
                  <Dropdown.Toggle variant='default' size='sm'>
                    <i className='bi bi-three-dots fs-4 p-0'></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className='p-0'>
                    <Dropdown.Item
                      onClick={() => {
                        showWrapperModal('Importar CSV')
                      }}
                      className='p-0 d-flex flex-row justify-content-center'
                    >
                      <div
                        className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                        style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          fill='currentColor'
                          className='bi bi-filetype-csv'
                          viewBox='0 0 16 16'
                          style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                        >
                          <path
                            fill-rule='evenodd'
                            d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z'
                          />
                        </svg>
                        <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                          Importar CSV
                        </p>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className='card-body'>
              <div className='row gap-2 mb-5'>
                <div className='col-4'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    value={locationId}
                    change={async (value: number) => {
                      setLocationId(value)
                      setLoading(true)
                      await getVariations(value)
                      setLoading(false)
                    }}
                    label={i18n.t(`smart_order.select_modality`)}
                    options={locations}
                  />
                </div>

                <div
                  className='col-4 text-muted h-100 d-flex align-items-center justify-content-end '
                  style={{
                    flex: 'auto',
                    marginTop: 'auto',
                  }}
                >
                  <div className='rounded border text-black shadow-sm p-3 bg-light-warning border-warning'>
                    <span>{i18n.t(`smart_order.message_warning_find_variation`)}</span>
                  </div>
                </div>
              </div>
              <Datatable
                data={variations}
                headers={[
                  {key: i18n.t(`smart_order.sku`), value: 'sku', type: 'default'},
                  {key: i18n.t(`smart_order.name`), value: 'name', type: 'default'},
                  {key: i18n.t(`smart_order.referenceCode`), value: 'code', type: 'default'},

                  {key: i18n.t(`smart_order.specification`), value: 'specification', type: 'html'},
                  {
                    key: i18n.t(`smart_order.price`),
                    value: 'price',
                    type: 'input-money',
                    disable: disableFieldsTotvs,
                    action: (item) => changeVariation(item, 'price'),
                  },
                  {
                    key: i18n.t(`smart_order.inventory`),
                    value: 'inventory',
                    type: 'input-number',
                    disable: disableFieldsTotvs,
                    action: (item) => changeVariation(item, 'inventory'),
                  },
                  {
                    key: 'Status',
                    value: 'status',
                    type: 'check',
                    action: (item) =>
                      switchStatus({endpoint: 'variations', Id: item.id, status: item.status}),
                  },
                  {key: i18n.t(`general.actions`), value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => {
                      navigate(`/variation/editar/${item.id}`)
                    },
                    title: `${i18n.t(`general.edit`)} ${i18n.t(`smart_order.variation`)}`,
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(
                        `${i18n.t(`general.delete`)} ${i18n.t(`smart_order.variation`)}`
                      )
                      setVariationId(item.id)
                    },
                    title: `${i18n.t(`general.delete`)} ${i18n.t(`smart_order.variation`)}`,
                  },
                ]}
                color='primary'
              />
            </div>
          </div>

          <ModalWrapper confirmAction={() => importFile()} textAction={'Confirmar'}>
            <div className='flex-grow-1'>
              <p>{i18n.t(`general.attention`)}</p>
              <p>
                Para importar os estoques mínimos, basta preencher o modelo abaixo com os seguintes
                padrões:
              </p>
              <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                <div
                  style={{
                    width: '70%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  sku/ean, estoque mínimo , largura, altura, profundidade, peso
                </div>
                <div style={{width: '30%'}}>
                  <Button
                    text={'Modelo'}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      window.open('/file/estoque_minimo_exemplo.xlsx', '')
                    }}
                    btnClass='fw-bolder me-5'
                  />
                </div>
              </div>
            </div>
            <br />
            <div className='flex-grow-1 text-center'>
              <Input
                inputAttr={{
                  type: 'file',
                }}
                acceptFile={'.xlsx,.xls'}
                change={(value: BaseSyntheticEvent) =>
                  setFileToImport(value ? value.target.files[0] : null)
                }
              />
            </div>
          </ModalWrapper>

          <ModalDelete confirmAction={() => deleteVariation()} />
        </div>
      )}
    </>
  )
}

const Variacoes: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`smart_order.variations`), path: 'variation', isActive: true},
        ]}
      >
        {i18n.t(`smart_order.variations`)}
      </PageTitle>
      <VariacoesContent />
    </>
  )
}

export {Variacoes}
